import { render } from "./F-Item.vue?vue&type=template&id=5a600c76"
import script from "./F-Item.vue?vue&type=script&lang=js"
export * from "./F-Item.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__